[
  {
    "id": "flat",
    "label": "Flat",
    "kind": "flat",
    "available": true
  },
  {
    "id": "iphone17",
    "label": "iPhone 17",
    "sourcePath": "/models/v1/ultramock-iphone17-lighting-v2-optimized-v1.glb",
    "thumbnail": "/device-thumbs/iphone17.png",
    "available": true,
    "bytes": 3632600,
    "localPath": "/models/v1/ultramock-iphone17-lighting-v2-optimized-v1.glb"
  },
  {
    "id": "iphone18Pro",
    "label": "iPhone 18 Pro",
    "sourcePath": "/models/apple/iphone18Pro-e1b2002805.glb",
    "thumbnail": "/device-thumbs/iphone18Pro.png",
    "available": true,
    "bytes": 5142220,
    "localPath": "/models/apple/iphone18Pro-e1b2002805.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/iphone-18-pro/2026/591df885-5ee2-4173-86e6-401021249f7c/ar/iphone-18-pro-e-sim.usdz",
    "sourcePage": "https://www.apple.com/iphone-18-pro/",
    "adaptedFromApple": true
  },
  {
    "id": "iphone18ProMax",
    "label": "iPhone 18 Pro Max",
    "sourcePath": "/models/apple/iphone18ProMax-20a7601caf.glb",
    "thumbnail": "/device-thumbs/iphone18ProMax.png",
    "available": true,
    "bytes": 5127712,
    "localPath": "/models/apple/iphone18ProMax-20a7601caf.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/iphone-18-pro/2026/591df885-5ee2-4173-86e6-401021249f7c/ar/iphone-18-pro-e-sim.usdz",
    "sourcePage": "https://www.apple.com/iphone-18-pro/",
    "adaptedFromApple": true
  },
  {
    "id": "iphoneDuo",
    "label": "iPhone Duo",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-iphoneDuo-unbranded-v1.glb",
    "thumbnail": "/device-thumbs/iphoneDuo.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "iphone17Pro",
    "label": "iPhone 17 Pro",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-iphone17Pro-lighting-v2-optimized-v1.glb",
    "thumbnail": "/device-thumbs/iphone17Pro.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "iphone17ProMax",
    "label": "iPhone 17 Pro Max",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-iphone17ProMax-lighting-v2-optimized-v1.glb",
    "thumbnail": "/device-thumbs/iphone17ProMax.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "watchUltra3",
    "label": "Apple Watch Ultra 3",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-watchUltra3-lighting-v2-optimized-v2.glb",
    "thumbnail": "/device-thumbs/watchUltra3.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "macbookPro16V2",
    "label": "MacBook Pro 16\"",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-macbook16V2-prepared-v2.glb",
    "thumbnail": "/device-thumbs/macbookPro16M3.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "macbookPro14",
    "label": "MacBook Pro 14\u2033",
    "sourcePath": "/models/apple/macbookPro14-9393f9fc76.glb",
    "thumbnail": "/device-thumbs/macbookPro14.png",
    "available": true,
    "bytes": 10849424,
    "localPath": "/models/apple/macbookPro14-9393f9fc76.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/macbook-pro/2025/785e1bc4-d1bd-4cf4-b1b3-94b9411c9e74/ar/macbook-pro-14-in-space-black-variant.usdz",
    "sourcePage": "https://www.apple.com/macbook-pro/",
    "adaptedFromApple": true
  },
  {
    "id": "macbookNeo",
    "label": "MacBook Neo",
    "sourcePath": "/models/v1/ultramock-macbookNeoV2-prepared-v1.glb",
    "thumbnail": "/device-thumbs/macbookNeo.png",
    "available": true,
    "bytes": 5838056,
    "localPath": "/models/v1/ultramock-macbookNeoV2-prepared-v1.glb"
  },
  {
    "id": "macbookAir13",
    "label": "MacBook Air 13\u2033",
    "sourcePath": "/models/apple/macbookAir13-da6c122916.glb",
    "thumbnail": "/device-thumbs/macbookAir13.png",
    "available": true,
    "bytes": 6673732,
    "localPath": "/models/apple/macbookAir13-da6c122916.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/macbook-air/2026/ff11cb38-708e-4c28-9653-1b01a2f8fd2b/ar/macbook-air-13in-sky-blue.usdz",
    "sourcePage": "https://www.apple.com/macbook-air/",
    "adaptedFromApple": true
  },
  {
    "id": "concreteStudioDisplay",
    "label": "Apple Studio Display",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-studioDisplay-unbranded-v1.glb",
    "thumbnail": "/device-thumbs/studioDisplay.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "studioDisplay",
    "label": "Studio Display",
    "sourcePath": "/models/apple/studioDisplay-be1e7bbe39.glb",
    "thumbnail": "/device-thumbs/studioDisplay.png",
    "available": true,
    "bytes": 6078100,
    "localPath": "/models/apple/studioDisplay-be1e7bbe39.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/studio-display/2026/fcc06a33-5854-47b3-bf6e-b8619f5a4f10/ar/studio-display.usdz",
    "sourcePage": "https://www.apple.com/studio-display/",
    "adaptedFromApple": true
  },
  {
    "id": "proDisplayXdrV2",
    "label": "Studio Display XDR",
    "sourcePath": "/models/apple/proDisplayXdrV2-0ff5be89b3.glb",
    "thumbnail": "/device-thumbs/proDisplayXdr.png",
    "available": true,
    "bytes": 8735424,
    "localPath": "/models/apple/proDisplayXdrV2-0ff5be89b3.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/studio-display-xdr/2026/78048978-2c59-4ed2-b23e-a626af616f46/ar/studio-display-xdr.usdz",
    "sourcePage": "https://www.apple.com/studio-display-xdr/",
    "adaptedFromApple": true
  },
  {
    "id": "ipadPro",
    "label": "iPad Pro",
    "sourcePath": "/models/apple/ipadPro-8f6343728f.glb",
    "thumbnail": "/device-thumbs/ipadPro.png",
    "available": true,
    "bytes": 9500400,
    "localPath": "/models/apple/ipadPro-8f6343728f.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/ipad-pro/2025/adee90db-c01e-430d-b726-fe64c0063f08/ar/ipad-pro-space-black.usdz",
    "sourcePage": "https://www.apple.com/ipad-pro/",
    "adaptedFromApple": true
  },
  {
    "id": "ipadAir",
    "label": "iPad Air",
    "sourcePath": "/models/apple/ipadAir-d3964321f2.glb",
    "thumbnail": "/device-thumbs/ipadAir.png",
    "available": true,
    "bytes": 8934520,
    "localPath": "/models/apple/ipadAir-d3964321f2.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/ipad-air/2025/e184d49a-4015-42ae-8a8b-db06bfeabd75/ar/ipad-air-blue-with-accessories.usdz",
    "sourcePage": "https://www.apple.com/ipad-air/",
    "adaptedFromApple": true
  },
  {
    "id": "galaxyS26Ultra",
    "label": "Galaxy S26 Ultra",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-galaxyS26Ultra-lighting-v2-optimized-v1.glb",
    "thumbnail": "/device-thumbs/galaxyS26Ultra.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "pixel10Pro",
    "label": "Pixel 10 Pro",
    "sourcePath": "/api/pro-assets/models/packed/v1/ultramock-pixel10Pro-lighting-v2-optimized-v2.glb",
    "thumbnail": "/device-thumbs/pixel10Pro.png",
    "available": false,
    "httpStatus": 403,
    "reason": "Requires service access"
  },
  {
    "id": "iphoneAir",
    "label": "iPhone Air",
    "sourcePath": "/models/apple/iphoneAir-0cc7b3cfa1.glb",
    "thumbnail": "/device-thumbs/iphoneAir.png",
    "available": true,
    "bytes": 5566032,
    "localPath": "/models/apple/iphoneAir-0cc7b3cfa1.glb",
    "sourceUrl": "https://www.apple.com/105/media/us/iphone-air/2025/731189b1-a606-493f-afa4-7c766a8fd08d/ar/iphone-air-e-sim.usdz",
    "sourcePage": "https://www.apple.com/iphone-air/",
    "adaptedFromApple": true
  },
  {
    "id": "homeview",
    "label": "HomeView",
    "sourcePath": "/models/v1/ultramock-homeview-usdz-optimized-v2.glb",
    "thumbnail": "/device-thumbs/homeview.png",
    "available": true,
    "bytes": 3642056,
    "localPath": "/models/v1/ultramock-homeview-usdz-optimized-v2.glb"
  }
]
